var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#F48E06"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.12502C16 10.4032 14.1532 12.25 11.875 12.25C11.612 12.25 11.3549 12.2251 11.1056 12.1781L10.5428 12.8112C10.4901 12.8706 10.4253 12.9181 10.3528 12.9506C10.2804 12.9832 10.2018 13 10.1224 13H9.25V13.9375C9.25 14.2482 8.99816 14.5 8.6875 14.5H7.75V15.4375C7.75 15.7482 7.49816 16 7.1875 16H4.5625C4.25184 16 4 15.7482 4 15.4375V13.608C4 13.4588 4.05927 13.3157 4.16474 13.2102L7.95698 9.418C7.82284 9.01127 7.75 8.57666 7.75 8.125C7.75 5.84683 9.5968 4.00002 11.875 4C14.1599 3.99998 16 5.8401 16 8.12502ZM11.875 7C11.875 7.62133 12.3787 8.125 13 8.125C13.6213 8.125 14.125 7.62133 14.125 7C14.125 6.37867 13.6213 5.875 13 5.875C12.3787 5.875 11.875 6.37867 11.875 7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/keyIcon.43b263ef63dbc90316e459caf1d46741.svg";
export { ForwardRef as ReactComponent };